<template>
    <div>
        AppAdmin
        <!--<v-btn @click="getData()">READ</v-btn>
        <v-btn @click="setData()">WRITE</v-btn>-->
    </div>
</template>

<script>
    //import {db} from "@/services/db";
    export default {
        name: "app-admin",
        /*
        data: () => ({
            result: [],
        }),
        methods: {
            async getData(){
                let i = 0;
                db.collection("spieler").where("search.lastAktiv.18112", ">=", '2021-06-30')
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            // doc.data() is never undefined for query doc snapshots
                            console.log(doc.id, " => ", doc.data());
                            if ( i < 20 ) {
                                this.result.push({id: doc.id, data: doc.data()});
                            }
                            i++;
                        });
                        localStorage.setItem('18112', JSON.stringify(this.result));
                        this.getDataPrivate();
                    })
                    .catch((error) => {
                        console.log("Error getting documents: ", error);
                    });
            },
                async getDataPrivate(){
                    const resultPrivate = [];
                    for ( let i = 0; i < this.result.length; i++ ) {
                        const spieler = this.result[i];
                        console.log ("aaa", spieler.id);
                        const privateData = await db.collection("spieler/" + spieler.id + '/private').doc(spieler.id).get();
                        console.log ("XXXXXXXX", privateData.data());
                        resultPrivate.push({id: spieler.id, data: privateData.data()})
                    }
                    console.log ("PRIVATE", resultPrivate);
                    localStorage.setItem('18112private', JSON.stringify(resultPrivate));
                },
            setData(){
                this.setDataFromList('18112');
                this.setDataFromListPrivate('18112private');
            },
            async setDataFromList(list){
                const spielerListe = JSON.parse(localStorage.getItem(list));
                for ( let i = 0; i < spielerListe.length; i++ ) {
                    const spieler = spielerListe[i];
                    console.log ("!!!!!!! ", spieler);
                    await db.collection("spieler").doc(spieler.id).set(spieler.data)
                }
            },
            async setDataFromListPrivate(list){
                const spielerListe = JSON.parse(localStorage.getItem(list));
                for ( let i = 0; i < spielerListe.length; i++ ) {
                    const spieler = spielerListe[i];
                    console.log ("!!!!!!!PRIVATE ", spieler);
                    await db.collection("spieler/" + spieler.id + '/private').doc(spieler.id).set(spieler.data)
                }
            }
        },
        */
    }
</script>

<style scoped>

</style>